/**
 * JQ4-17 · US-CONFIG-003 — Hotel exit/re-entry registration route.
 *
 * Path: /hotel-exits/:ticketId
 * Access: authenticated operators on Hotel-niche locations.
 *
 * Route params:
 *   ticketId  — UUID of the parked ticket
 *
 * Search params (optional, pre-populate the view without a fetch):
 *   ticketNumber — display ticket number
 *   plate        — vehicle plate
 *   vehicleOut   — '1' if vehicle currently out, else '0' (default '0')
 */

import { createFileRoute, useRouter } from '@tanstack/react-router';
import { z } from 'zod';

import { HotelExitsPage } from '../modules/hotel/ui/pages/HotelExitsPage.js';

const searchSchema = z.object({
  ticketNumber: z.coerce.number().int().positive().optional(),
  plate: z.string().optional(),
  vehicleOut: z.enum(['0', '1']).optional(),
});

export const Route = createFileRoute('/_authenticated/hotel-exits/$ticketId')({
  validateSearch: (search) => searchSchema.parse(search),
  component: HotelExitsRoute,
});

function HotelExitsRoute() {
  const { ticketId } = Route.useParams();
  const { ticketNumber = 0, plate = '—', vehicleOut = '0' } = Route.useSearch();
  const router = useRouter();

  return (
    <HotelExitsPage
      ticketId={ticketId}
      ticketNumber={ticketNumber}
      plate={plate}
      vehicleOut={vehicleOut === '1'}
      onBack={() => router.history.back()}
    />
  );
}
